import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const planSetupPageRoute: InvariantJiraRoute = {
	name: 'software-advanced-roadmaps-setup',
	path: '/jira/plans/:planId/setup',
};
